/**
 * ElectionsCalendarPage — the Elections Calendar (CALENDAR_SEPARATION_PRD
 * §5.2): the same month/week/day calendar as the Legislative Calendar, showing
 * election events — registry milestones (election source), public political
 * events (resolved O1), and the caller's own workspace events (cross-cutting,
 * resolved O2). Never the legislative source: hearings belong to /calendar.
 */

import React from 'react';
import PageShell from '../components/PageShell';
import CalendarTab from '../components/workspace/tabs/CalendarTab/CalendarTab';
import type { CalendarEventSource } from '../types/calendar';

// Module-level so hook identities stay stable.
const ELECTION_SOURCES: CalendarEventSource[] = ['election', 'public', 'workspace'];

const ElectionsCalendarPage: React.FC = () => {
  return (
    <PageShell
      title="Election Calendar"
      description="Election deadlines, milestones, and political events"
      helpContentKey="elections-calendar"
    >
      <CalendarTab hideHeading sources={ELECTION_SOURCES} />
    </PageShell>
  );
};

export default ElectionsCalendarPage;
